import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MARKETING_SUCCESS_ROADMAP_HEADING,
  MARKETING_SUCCESS_ROADMAP_STEPS,
  type MarketingSuccessRoadmapStep,
} from './marketing-success-roadmap.data';

@Component({
  selector: 'app-marketing-success-roadmap',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="h1-section h1-section--warm" id="roadmap">
      <div class="h1-section__inner">
        <header class="h1-section__head h1-section__head--center">
          <h2>{{ heading.title }}</h2>
          <p>{{ heading.subtitle }}</p>
        </header>

        <ol class="h1-roadmap">
          <div class="h1-roadmap__line" aria-hidden="true"></div>
          @for (step of steps; track step.title; let i = $index) {
            <li class="h1-roadmap__step">
              <div class="h1-roadmap__icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  focusable="false"
                >
                  @switch (step.icon) {
                    @case ('search') {
                      <circle cx="11" cy="11" r="7"></circle>
                      <path d="m20 20-3.5-3.5"></path>
                    }
                    @case ('file-text') {
                      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                      <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                      <path d="M8 13h8"></path>
                      <path d="M8 17h8"></path>
                      <path d="M8 9h2"></path>
                    }
                    @case ('graduation-cap') {
                      <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path>
                      <path d="M22 10v6"></path>
                      <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                    }
                    @case ('stamp') {
                      <path d="M5 22h14"></path>
                      <path
                        d="M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z"
                      ></path>
                      <path
                        d="M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1.34-3 3 0 2 1 2 1 3.5V13"
                      ></path>
                    }
                    @case ('plane') {
                      <path
                        d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"
                      ></path>
                    }
                  }
                </svg>
              </div>
              <div class="h1-roadmap__index">Step {{ i + 1 }}</div>
              <div class="h1-roadmap__title">{{ step.title }}</div>
              <div class="h1-roadmap__desc">{{ step.description }}</div>
            </li>
          }
        </ol>
      </div>
    </section>
  `,
})
export class MarketingSuccessRoadmapComponent {
  readonly heading = MARKETING_SUCCESS_ROADMAP_HEADING;
  readonly steps: MarketingSuccessRoadmapStep[] = MARKETING_SUCCESS_ROADMAP_STEPS;
}
